import { Entity, randomBool, randomIntBetween } from "game-common/models"

export interface ScreenShakeState {
    isShaking: boolean
    shakeOffsetX: number
    shakeOffsetY: number
}

export class ScreenShakeManager {
    private state: ScreenShakeState = {
        isShaking: false,
        shakeOffsetX: 0,
        shakeOffsetY: 0,
    }

    private readonly screenshakeEnabled: boolean = true

    /**
     * Get current shake state
     */
    public getState(): ScreenShakeState {
        return { ...this.state }
    }

    /**
     * Update shake offsets
     */
    public setShakeOffsets(x: number, y: number): void {
        this.state.shakeOffsetX = x
        this.state.shakeOffsetY = y
    }

    /**
     * Reset shake state
     */
    public reset(): void {
        this.state.shakeOffsetX = 0
        this.state.shakeOffsetY = 0
        this.state.isShaking = false
    }

    /**
     * Trigger screen shake effect
     */
    public screenShake(entity: Entity, onUpdate: (entity: Entity) => void): void {
        if (!this.screenshakeEnabled) {
            return
        }
        if (this.state.isShaking) {
            return
        }

        this.state.isShaking = true
        let startTs = Date.now()
        let shakeDirLeft = randomBool()
        let shakeDistance = randomIntBetween(5, 8)
        let currentShakeDistance = shakeDistance
        let duration = randomIntBetween(40, 60)
        let up: boolean = randomBool()

        const interval = setInterval(() => {
            let elapsed = Date.now() - startTs
            if (elapsed > duration) {
                clearInterval(interval)
                this.state.shakeOffsetX = 0
                this.state.shakeOffsetY = 0
                this.state.isShaking = false

                onUpdate(entity)
                return
            }

            if ((elapsed / duration) % 0.25 === 0 || currentShakeDistance <= 0) {
                shakeDirLeft = !shakeDirLeft
                shakeDistance = shakeDistance - 1
                currentShakeDistance = shakeDistance
            }

            currentShakeDistance -= 1
            this.state.shakeOffsetX += shakeDirLeft ? 1 : -1
            onUpdate(entity)

            this.state.shakeOffsetY += up ? -1 : 1
            up = !up
        }, 10)
    }
}
